import { render } from "./transit-detail.vue?vue&type=template&id=04db71d1&scoped=true"
import script from "./transit-detail.vue?vue&type=script&lang=js"
export * from "./transit-detail.vue?vue&type=script&lang=js"

import "./transit-detail.vue?vue&type=style&index=0&id=04db71d1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04db71d1"]])

export default __exports__